
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1254 850","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMinYMin slice","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".3","clip-path":"url(#svg-graphic-2__clip0_3733_130983)"}},[_c('path',{attrs:{"d":"M955.506-56.225L641.328 125.19l314.178 181.369V-56.225z","fill":"#F2D2D4"}}),_c('path',{attrs:{"d":"M955.512-56.224V306.56l314.178-181.415v-362.784L955.512-56.224z","fill":"#BF1D30"}}),_c('path',{attrs:{"d":"M1269.69 125.146L955.512 306.561l314.178 181.415 314.13-181.415-314.13-181.415z","fill":"#D93844"}}),_c('path',{attrs:{"d":"M641.328-237.639v362.83L955.506-56.224 641.328-237.639z","fill":"#E7A6AB"}}),_c('path',{attrs:{"d":"M641.328 125.146L327.195 306.561l314.133 181.415 314.179-181.415-314.179-181.415z","fill":"#D93844"}}),_c('path',{attrs:{"d":"M327.195 669.392l314.133-181.415-314.133-181.415v362.83z","fill":"#E7A6AB"}}),_c('path',{attrs:{"d":"M327.199 669.391L0 858.338h641.332v-7.533L327.199 669.391z","fill":"#D93844"}}),_c('path',{attrs:{"d":"M955.506 669.391L641.328 850.805v7.533h628.352v-7.533L955.506 669.391z","fill":"#D93844"}}),_c('path',{attrs:{"d":"M641.328 487.975L327.195 669.389l314.133 181.415V487.975z","fill":"#F2D2D4"}}),_c('path',{attrs:{"d":"M641.328 487.977v362.829l314.178-181.414v-362.83L641.328 487.977z","fill":"#BF1D30"}}),_c('path',{attrs:{"d":"M955.512 669.389l314.178 181.415V487.975L955.512 669.389z","fill":"#F2D2D4"}}),_c('path',{attrs:{"d":"M1269.69 487.977L955.512 306.562v362.83l314.178-181.415z","fill":"#E7A6AB"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"svg-graphic-2__clip0_3733_130983"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 -608)","d":"M0 0h1898v1466.34H0z"}})])])])
          )
        }
      }
    